import { Theme, ThemeName } from '@/types/theme';
import logo from '@/images/webinar_plus_logo.svg?react';
import WebinarPlusBackdrop from './webinar-plus/webinar-plus-backdrop/webinar-plus-backdrop';

const webinarPlus: Theme = {
  name: ThemeName.WEBINAR_PLUS,
  backdrop: {
    component: WebinarPlusBackdrop,
  },
  logo: logo,
};

export default webinarPlus;
